import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  invoiceRouter: Array<RouteRecordRaw> = [
    {
        path: '/invoice',
        name: '财务管理',
        component: Layout,
        redirect: '/invoice/list',
        meta: { title: '财务管理', icon: 'icon-invoice', alwaysShow: true },
        children: [
            // {
            //     path: 'list',
            //     name: '发票列表',
            //     component: () => import('@/views/invoice/List.vue'),
            //     meta: { title: '发票列表' , keepAlive: true, depth: 30}
            // },
            // {
            //     path: 'edit',
            //     name: '发票编辑',
            //     component: () => import('@/views/invoice/Edit.vue'),
            //     meta: { title: '发票编辑', hidden: true }
            // },
            {
                path: 'invoice-check',
                name: '发票审核',
                component: () => import('@/views/merchant/InvoiceList.vue'),
                meta: {
                    title: '发票审核',
                    v: 2,   // 账务端
                    keepAlive: true,
                    depth: 30,
                    badge: 'invoice'
                }
            },
            {
                path: 'invoice-edit',
                name: '发票审核编辑',
                component: () => import('@/views/merchant/InvoiceEdit.vue'),
                meta: { title: '发票审核编辑', depth: 40 }
            },
            {
                path: 'accountchecklist',
                name: '对账列表',
                component: () => import('@/views/invoice/AccountCheckList.vue'),
                meta: { title: '对账列表', keepAlive: true, depth: 30}
            },
            {
                path: 'channelAccountCheckList',
                name: '渠道对账列表',
                component: () => import('@/views/invoice/ChannelAccountCheckList.vue'),
                meta: { title: '渠道对账列表', keepAlive: true, depth: 30}
            },
            {
                path: 'showOrderList',
                name: '财务对账订单列表',
                component: () => import('@/views/invoice/showOrderList.vue'),
                meta: { title: '财务对账订单列表', keepAlive: true, depth: 30}
            },
            {
                path: 'uploadinvoice',
                name: '对账发票信息',
                component: () => import('@/views/invoice/uploadInvoice.vue'),
                meta: { title: '对账发票信息'}
            },
            {
                path: 'prepay',
                name: '渠道预付款',
                component: () => import('@/views/invoice/PrepayList.vue'),
                meta: { title: '渠道预付款' }
            },
            {
                path: 'price-log',
                name: '改价记录列表',
                component: () => import('@/views/invoice/PriceLog.vue'),
                meta: { title: '改价记录列表' }
            },
            {
                path: 'shop_reconciliation-list',
                name: '商家对账',
                component: () => import('@/views/invoice/ShopReconciliationList.vue'),
                meta: { title: '商家对账', keepAlive: true, depth: 30 }
            },
            {
                path: 'shop_reconciliation-detail',
                name: '商家对账详情',
                component: () => import('@/views/invoice/ShopReconciliationEdit.vue'),
                meta: { title: '商家对账详情' }
            },
            {  
                path: 'reconciliation-list',
                name: '供应商对账',
                component: () => import('@/views/invoice/ReconciliationList.vue'),
                meta: { title: '供应商对账' }
            },
            {
                path: 'reconciliation-detail',
                name: '供应商对账详情',
                component: () => import('@/views/invoice/ReconciliationEdit.vue'),
                meta: { title: '供应商对账详情' }
            },
            
        ]
    }
]

export default  invoiceRouter